var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Section',[_c('div',{staticClass:"flex-center"},[_c('img',{attrs:{"src":require("@/assets/gems_error_logo.png")}}),_c('span',[_c('h2',[_vm._v("The page you tried to load does not exist.")]),_vm._v(" "),_c('br'),_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }